<div
  class="overlay"
  [ngClass]="{ show: isVisible }"
>
  <div class="trial">
    <div class="pictureContainer">
      <ng-container *ngIf="!showingPracticeFeedback">
        <ng-container *ngIf="trial">
          <img [src]="trialImgSrc" draggable="false" />
        </ng-container>
      </ng-container>
      <div *ngIf="showingPracticeFeedback" class="practiceFeedback">
        {{ practiceFeedbackMessage }}
      </div>
    </div>
    <div class="responseContainer">
      <p *ngIf="testResponseTime && showClassification()">
        {{ classificationResponseTimeForTesting }}
      </p>
      <p *ngIf="testResponseTime && showIntensityRating()">
        {{ intensityRatingResponseTimeForTesting }}
      </p>
      <app-classification-choices
        *ngIf="showClassification() && trial && !showingPracticeFeedback"
        [choices]="emotionChoices()"
        (choiceSelected)="classicationChoiceSelected($event)"
      ></app-classification-choices>
      <app-intensity-rating
        *ngIf="showIntensityRating() && trial"
        (ratingConfirmed)="intensityRatingConfirmed($event)"
      ></app-intensity-rating>
    </div>
  </div>
</div>
